import { ButtonV2 } from '@findy-code/yuffie/ui/button/v2';
import Link from 'next/link';
import { FaChevronDown, FaEdit } from 'react-icons/fa';

import { CloseButton } from '../components/close-button';
import styles from './sent-like-button-group.component.module.scss';

type Props = {
  companyName: string;
  isOpen?: boolean;
  onClose?: () => void;
};

/**
 * ユーザから求人に対して「いいかも」を送信している場合に表示されるボタン郡
 */
export const SentLikeButtonGroup = ({
  companyName,
  isOpen,
  onClose,
}: Props) => {
  const openClass = isOpen ? 'open' : undefined;

  return (
    <div className={`${openClass} ${styles.sentLikeButtonGroupWrapper}`}>
      <div className={styles.sentLikeContents}>
        <div>
          <p className={styles.sentLikeButtonGroupMessage}>
            {`${companyName}の求人に`}
            <br />
            「いいかも」を送りました
          </p>
          <p className={styles.sentLikeButtonGroupSPHiddenMessage}>
            プロフィール情報を充実させると、企業とのマッチング率がUPします。
          </p>
        </div>
        <div className={`${openClass} ${styles.sentLikeButtonWrapper}`}>
          <Link legacyBehavior passHref href="/settings/profile">
            <ButtonV2 as="a" startIcon={FaEdit}>
              プロフィールを編集する
            </ButtonV2>
          </Link>
        </div>
      </div>
      <CloseButton
        aria-label="閉じる"
        className={openClass}
        type="button"
        onClick={onClose}
      >
        <FaChevronDown aria-hidden="true" size="16" />
      </CloseButton>
    </div>
  );
};
